import UserTable from "./UserTable";
import React, {useContext, useEffect, useState} from "react";
import {SiteContext} from "../../utils/SiteContext";
import UserDetails from "./UserDetails";
import SearchBar from "../../site components/SearchBar";
import UserCompanies from "./UserCompanies";
import SignUpModal from "../login/UserSignUp";
import {Box} from "@mui/material";
import {ManageUsersContext} from "./ManageUsersContext";
import {GetAllCompanies} from "../../utils/AxiosUtils";

export default function ManageUsersPage() {
    const {alert} = useContext(SiteContext);
    const {user, companies} = useContext(ManageUsersContext);
    // const [userVal,setUser] = user;
    const [companiesVal,setCompanies] = companies;
    const [alertBar, setAlertBar] = alert;
    const [searchVal, setSearch] = useState('');
    const search = [searchVal, setSearch];
    const [page, setPage] = useState({pg_size: 20, page: 1, count: 0})
    const [open, setOpen] = useState(false);
    // const [user, setUser] = useState();
    // const [companies, setCompanies] = useState([]);

    useEffect(()=>{
        GetAllCompanies(setCompanies);
    },[])

    return (


        <Box sx={{ height: `calc(100vh - 110px)`, display: 'flex', flexDirection: 'column' }}>

            {/* Main container with flex layout */}
            <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: 2, flexGrow: 1, height: '100%' }}>
                
                {/* Left Column: User Table */}
                <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
                <SearchBar search={search} page={[page, setPage]} label="Users"/>
                <UserTable
                    search={search}
                    page={[page, setPage]}
                    user={user}
                    onAddUser={() => setOpen(true)}
                />
                </Box>

                {/* Right Column: Details & Companies */}
                <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Box sx={{ minHeight: 200 }}>
                    <UserDetails user={user} />
                </Box>
                <Box sx={{ flex: 2, minHeight: 200 }}>
                    <UserCompanies user={user} />
                </Box>
                </Box>
            </Box>

            <SignUpModal open={open} setOpen={setOpen} alertBar={alertBar} setAlertBar={setAlertBar} />
        </Box>


    )
}